module.exports = __webpack_public_path__ + "img/food-32.f3bbd8e9.jpg";